import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { Showroom } from "../types";
import {
	createShowroomAsync,
	CreateShowroomPayload,
	getListShowroomAsync,
	GetListShowroomAsyncPayload,
	getShowroomAsync,
	GetShowroomPayload,
	resetDetailShowroom,
	setDetailShowroom,
	setListShowroom,
	updateShowroomAsync,
	UpdateShowroomPayload,
} from "./showroom.slice";

// Get list
function* getShowroomsSaga(action: PayloadAction<GetListShowroomAsyncPayload>) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Showroom[]>>(
				"/dashboard/showrooms",
				query,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListShowroom.type, payload: response });
		callback && callback();
	} else {
		message.error(translate(error.message));
	}
}

// Get detail
function* getShowroomSaga(action: PayloadAction<GetShowroomPayload>) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Showroom>>(
				`/dashboard/showrooms/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback(response.data);
		yield put({ type: setDetailShowroom.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

// update showroom
function* updateShowroomSaga(action: PayloadAction<UpdateShowroomPayload>) {
	const { id, callback, showroom } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch<ApiResponse<Showroom>>(
				`/dashboard/showrooms/${id}`,
				showroom,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback(response.data);
		yield put({ type: setDetailShowroom.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

// create showroom
function* createShowroomSaga(action: PayloadAction<CreateShowroomPayload>) {
	const { callback, showroom } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post<ApiResponse<Showroom>>(
				"/dashboard/showrooms",
				showroom,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback(response.data);
		yield put({ type: resetDetailShowroom.type });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetShowrooms() {
	yield takeLatest(getListShowroomAsync, getShowroomsSaga);
}

function* watchGetShowroom() {
	yield takeLatest(getShowroomAsync, getShowroomSaga);
}

function* watchUpdateShowroom() {
	yield takeLatest(updateShowroomAsync, updateShowroomSaga);
}

function* watchCreateShowroom() {
	yield takeLatest(createShowroomAsync, createShowroomSaga);
}

const showroomSaga = [
	watchGetShowrooms(),
	watchGetShowroom(),
	watchUpdateShowroom(),
	watchCreateShowroom(),
];

export default showroomSaga;
